export const environment = {
    production: true,
    name: "dev",
    version: '1.0.9',
    isWriteLogCW: true,
    firebaseConfig: {
        apiKey: "AIzaSyB8Q2Ee9iXyOAGCsBVtUdDgb5fVXdo6xwg",
        authDomain: "athena-dev-7e581.firebaseapp.com",
        databaseURL: "https://athena-dev-7e581-default-rtdb.asia-southeast1.firebasedatabase.app",
        projectId: "athena-dev-7e581",
        storageBucket: "athena-dev-7e581.appspot.com",
        messagingSenderId: "118836796888",
        appId: "1:118836796888:web:2f906e07e7dc24674ee6ad",
        measurementId: "G-5HV4K73VC4"
    },
    awsCloudWatch: {
        awsAccessKey: "AKIAQMFF4KIADSTOOXXD",
        awsSecretKey: "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",
        awsRegion: "ap-southeast-1",
        logGroupName: "cognito-athena-dev",
        logStreamName: "ihunt"
    },
    sentry_dns: 'https://a6dd7674284349fa9f08beb248a2149f@o1014340.ingest.sentry.io/4504330460659712',
    sentry_tracing: ["https://hunt-dev.a4b.vn/", "https://athenahunt.athenafs.io/"],
    awsmobile: {
        "aws_project_region": "ap-southeast-1",
        "aws_cognito_region": "ap-southeast-1",
        "aws_user_pools_id": "ap-southeast-1_RjTZaBe1q",
        "aws_user_pools_web_client_id": "2uimogh9ciprc3jpk1k6rl9vp5",
        "oauth": {
            "domain": "isign-prod.auth.ap-southeast-1.amazoncognito.com",
            "scope": [
                "email",
                "openid",
                "phone"
            ],
            "redirectSignIn": "https://www.google.com.vn/",
            "redirectSignOut": "https://www.google.com.vn/",
            "responseType": "code"
        },
        "federationTarget": "COGNITO_USER_POOLS",
        "aws_cognito_username_attributes": [
            "EMAIL"
        ],
        "aws_cognito_social_providers": [],
        "aws_cognito_signup_attributes": [
            "GIVEN_NAME",
            "FAMILY_NAME"
        ],
        "aws_cognito_mfa_configuration": "OFF",
        "aws_cognito_mfa_types": [],
        "aws_cognito_password_protection_settings": {
            "passwordPolicyMinLength": 8,
            "passwordPolicyCharacters": [
                "REQUIRES_LOWERCASE",
                "REQUIRES_UPPERCASE",
                "REQUIRES_NUMBERS",
                "REQUIRES_SYMBOLS"
            ]
        },
        "aws_cognito_verification_mechanisms": [
            "EMAIL"
        ]
    }
};
